import { getFirebase } from 'react-redux-firebase'
import { userConstants } from '../constants/user.constants'
import { alertActions } from './alert.actions'
import { entityActions, refUpdate, refSave } from './entity.actions'
import { homeActions } from './home.actions'
import { humanize } from 'underscore.string'
import { Roles } from '../utils/Roles'
import { getCurrentUserId } from '../selectors/user.selector'
import { getProjectId } from '../selectors/project.selector' 

const deleteUser = (user) => {
  const firebase = getFirebase()

  return async (dispatch, getState) => {
    const state = getState()

    const projectId = getProjectId(state)
    const userId = user.uid

      await firebase
      .database()
      .ref(`projects/${projectId}/users/${userId}`)
      .remove()


      await firebase
      .database()
      .ref(`projects/${projectId}/roles/${userId}`)
      .remove()
  }
}

const deleteInvite = (invite) => {
  const firebase = getFirebase()

  return async (dispatch, getState) => {
    const state = getState()

    const projectId = getProjectId(state)
    const inviteId = invite.uid

    await firebase
    .database()
    .ref(`user_invites/${inviteId}`)
    .remove()
  }
}

const savePhoneNumber = (userId, phoneNumber) => {
  const firebase = getFirebase()

  return async (dispatch, getState) => {

    await firebase.database().ref(`/users/${userId}`).update({phoneNumber})
  }
}

export const userActions = {
  login,
  logout,
  signUpUser,
  createSubscription,
  loginWithGoogle,
  changeUserRole,
  toggleDailyUpdate,
  toggleDailyCommit,
  deleteUser,
  deleteInvite,
  savePhoneNumber
}

function toggleDailyUpdate(projectId, hasDailyUpdates, currentUserId) {
  const firebase = getFirebase()

  return (dispatch, getState) => {
    if(hasDailyUpdates) {
      return firebase
        .database()
        .ref(`projects/${projectId}/dailyUpdateUsers/${currentUserId}`)
        .remove()
    } else {
      return refSave(
        firebase,
        firebase.database().ref(`projects/${projectId}/dailyUpdateUsers/${currentUserId}`),
        true
      )
    }
    
  }
}

function toggleDailyCommit(hasDailyUpdates) {
  const firebase = getFirebase()

  return (dispatch, getState) => {
    const state = getState()
    const userId = getCurrentUserId(state)
    const projectId = getProjectId(state)
    if(hasDailyUpdates) {
      return firebase
        .database()
        .ref(`projects/${projectId}/commitDaily/${userId}`)
        .remove()
    } else {
      return refSave(
        firebase,
        firebase.database().ref(`projects/${projectId}/commitDaily/${userId}`),
        true
      )
    }
    
  }
}

function loginWithGoogle() {
  const firebase = getFirebase()
  const provider = new firebase.auth.GoogleAuthProvider()
  return (dispatch, getState) => {
    return firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {})
      .catch(err => {})
  }
}

function createSubscription(tokenId, projectId, plan) {
  const firebase = getFirebase()
  console.log(`adding subscription to ${projectId}`)
  return (dispatch, getState) => {
    const user = firebase.auth().currentUser
    return Promise.all([
      refUpdate(firebase, firebase.database().ref(`/users/${user.uid}`), {
        stripe_token_id: tokenId
      })
    ])
      .then(() => {
        return refSave(
          firebase,
          firebase.database().ref(`/projects/${projectId}/subscription`),
          {
            payeeId: user.uid,
            projectId: projectId,
            status: 'pending',
            plan: plan
          }
        )
      })
      .then(() => {
        dispatch(homeActions.closeChangeSubscriptionDialog())
      })
  }
}

function changeUserRole(projectId, userId, newRole) {
  const firebase = getFirebase()
  const url = `/projects/${projectId}/roles/${userId}/`
  return (dispatch, getState) => {
    return refUpdate(firebase, firebase.database().ref(url), {
      type: newRole
    }).then(() => {
      dispatch(alertActions.success('Roles Updated'))
    })
  }
}

function login(email, password) {
  const firebase = getFirebase()
  return dispatch => {
    dispatch(
      request({
        email: email
      })
    )
    firebase
      .login({
        email: email,
        password: password
      })
      .then(
        user => {
          dispatch(
            success({
              uid: user.user.user.uid,
              email: user.user.user.email
            })
          )
        },
        error => {
          dispatch(failure(error.toString()))
          dispatch(alertActions.error(error.toString()))
        }
      )
      .catch(error => {
        dispatch(alertActions.error(error.toString()))
      })
  }

  function request(user) {

    return {
      type: userConstants.LOGIN_REQUEST,
      user: user,
      meta: {
        mixpanel: {
          eventName: 'LOGIN-REQUEST-EVENT',
          props: {
            email: user.email,
            source: 'website'
          }
        },
         
      }
    }
  }

  function success(user) {
    return {
      type: userConstants.LOGIN_SUCCESS,
      user: user
    }
  }

  function failure(error) {
    return {
      type: userConstants.LOGIN_FAILURE,
      error: error,
      meta: {
        mixpanel: {
          eventName: 'LOGIN-ERROR-EVENT',
          props: {
            email: humanize(error),
            source: 'website'
          }
        },
         
      }
    }
  }
}

const getInviteByEmailOrPhone = async (firebase, user_email, phoneNumber) => {
  const Emailsnap = await firebase
    .database()
    .ref('user_invites')
    .orderByChild('user_email')
    .equalTo(user_email.toLowerCase())
    .once('value')

  const Phonesnap = await firebase
    .database()
    .ref('user_invites')
    .orderByChild('phoneNumber')
    .equalTo(phoneNumber)
    .once('value')

    if(Emailsnap.exists()) {
      return Emailsnap
    }

    if(Phonesnap.exists()) {
      return Phonesnap
    }
}

const checkForInvites = async (firebase, user_email, phoneNumber, user_id) => {
  const snap = await getInviteByEmailOrPhone(firebase, user_email, phoneNumber)
  
    if (!snap || !snap.val()) return
    const promises = Object.entries(snap.val()).map(([key, userInvite]) => {
      return firebase
        .database()
        .ref('/projects/' + userInvite.project_uid)
        .once('value', projectSnap => {
          const projectsRolesPromise = refSave(
            firebase,
            firebase
              .database()
              .ref(
                '/projects/' + userInvite.project_uid + '/roles/' + user_id
              ),
            {
              type: Roles.COLLABORATOR
            }
          )

          const projectsUsersPromise = refSave(
            firebase,
            firebase
              .database()
              .ref(
                '/projects/' + userInvite.project_uid + '/users/' + user_id
              ),
            true
          )
          const userProjectPromise = refSave(
            firebase,
            firebase
              .database()
              .ref(
                '/users/' + user_id + '/projects/' + userInvite.project_uid
              ),
            { name: projectSnap.val().name }
          )
          return Promise.all([
            projectsUsersPromise,
            userProjectPromise,
            projectsRolesPromise
          ]).then(() => {
            firebase
              .database()
              .ref('/user_invites/' + key)
              .remove()
          })
        })
    })

    return Promise.all(promises)
    
}

function signUpUser(email, password, firstName, lastName, phoneNumber) {
  const firebase = getFirebase()
  return dispatch => {
    dispatch(
      request({
        email: email
      })
    )
    return firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(user => {
        return entityActions
          .saveProfile(firebase, email, firstName, lastName, user.user, phoneNumber)
          .then(() => {
            return Promise.resolve(user.user)
          })
      })
      .then(user => {
        return checkForInvites(firebase, email, phoneNumber, user.uid).then(() => {
          return Promise.resolve(user)
        })
      })
      .then(user => {
        dispatch(success(user))
      })
      .catch(error => {
        dispatch(failure(error.toString()))
        dispatch(alertActions.error(error.toString()))
      })
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error }
  }

  function request(user) {
    return {
      type: userConstants.REGISTER_REQUEST,
      user: user,
      meta: {
        mixpanel: {
          eventName: 'SIGNUP-REQUEST-EVENT',
          props: {
            email: user.email,
            source: 'website'
          }
        },
         
      }
    }
  }

  function success(user) {
    return {
      type: userConstants.REGISTER_SUCCESS,
      user: user,
      meta: {
        mixpanel: {
          eventName: 'SIGNUP-EVENT',
          props: {
            email: user.email,
            source: 'website'
          }
        },
         
      }
    }
  }

  function failure(error) {
    return {
      type: userConstants.REGISTER_FAILURE,
      error: error,
      meta: {
        mixpanel: {
          eventName: 'SIGNUP-ERROR-EVENT',
          props: {
            email: humanize(error),
            source: 'website'
          }
        },
         
      }
    }
  }
}

function logout() {
  const firebase = getFirebase()
  const user = firebase.auth().currentUser
  firebase.auth().signOut()
  return {
    type: userConstants.LOGOUT,
    user: user,
    meta : {
       
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js